define([
    'text!WebCommon/component/image-360-new20242.html',
    // 'common/api',
    'jquery',
    'vendor/swiper/swiper-bundle.min.js',//线上
    // '../../../../../vendor/swiper/swiper-bundle.min.js',//测试

    'css!vendor/swiper/swiper-bundle.min.css',
    'css!WebCommon/component/image-360-new.css',
    'css!WebCommon/component/image-360-new20242.css'

], function(
    tpl,
    // Api,
    $,
    Swiper
){
    return {
        template: tpl,
        data: function(){
            return {
                mySwiper: ''
            };
        },
        // 这里是传入的数据
        props: {
            images: {
                type: Array,
                default: function () {
                    return []
                }
            },
            SwiperType: String,
            dotsShow: {
                type: Number
            }
        },
        methods: {
            init: function () {
                var _this = this;
                if(this.SwiperType=='image360'){
                    _this.mySwiper = new Swiper('#image360-new',{
                        slidesPerView: 2,
                        // loop: true,
                        // spaceBetween: 1000,
                        // centeredSlides: true,
                        observer: true,
                        effect : 'fade',
                        autoplay: {
                            delay: 2500,
                            disableOnInteraction: false,
                        },
                        pagination: {
                            el: '.swiper-pagination',
                            clickable: true,
                        }
                    });
                }
            },
            toSwiperPage: function (index) {
                this.mySwiper.slideTo(index);
            }
        },
        watch: {
            SwiperType: function () {
                this.init();
            }
        },
        mounted: function(){
            this.init();
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ../common/component/image-360-new20242.js
// module id = 300
// module chunks = 2